import { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import FormattedDate, {
  DATE_FORMATS,
} from "basicComponents/FormattedDate/Formatted";
import TimeWindowCheckBox from "../TimeWindowCheckBox/TimeWindowCheckBox";
import moment from "moment";

export default class TimeWindow extends Component {
  static propTypes = {
    date: PropTypes.string.isRequired,
    times: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
    locale: PropTypes.string,
  };

  state = {};

  render() {
    const date = moment(this.props.date, "YYYY-MM-DD");
    return (
      <Wrapper id={date.format("DD-MM-YYYY")}>
        <Date>
          <FormattedDate
            date={date}
            format={DATE_FORMATS.HUMAN_READABLE_DATE}
          />
        </Date>
        {this.props.times.map(time => (
          <TimeWindowCheckBox
            key={`${JSON.stringify(time.timewindow)}`}
            time={time}
            onClick={this.props.onClick}
            locale={this.props.locale}
          />
        ))}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  border: 2px solid #a7e1f1;
  background-color: #d4eef8;
  padding: ${({ theme }) => theme.padding}rem;
  border-radius: 4px;
  width: calc(50% - ${({ theme }) => theme.margin / 2}rem);
  margin-bottom: 25px;
`;

const Date = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;
